export default "__VITE_ASSET__DMnLa9BY__"